module.exports = __webpack_public_path__ + "static/about-two-570bf78427bf6b9836244562f4e173e0.webp";